import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import image from './images/googleimg.png';
import logo from './images/Neobot.png';
import './App.css';

const SignIn = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const login = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        setLoading(true);

        // ? Fetch user info using access_token
        const res = await fetch(
          `https://www.googleapis.com/oauth2/v3/userinfo`,
          {
            headers: { Authorization: `Bearer ${response.access_token}` },
          }
        );

        const data = await res.json();
        const userEmail = data.email;

        if (!userEmail) {
          throw new Error("Email not found in Google response");
        }

        // Save user email
        sessionStorage.setItem('userEmail', userEmail);

        // Fire-and-forget folder creation
        fetch('https://neobot.d-rosa.ai/api/user_folder', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            path: '/var/www/neobot/myflaskapp/flask_static',
            folder_name: userEmail,
          }),
        }).catch((err) => console.error('Folder creation error:', err));

        // ? Navigate now
        navigate('/main');
      } catch (error) {
        setMessage('Unexpected error during login.');
        console.error('Login error:', error);
        setLoading(false);
      }
    },
    onError: () => {
      setMessage('Google Login Failed');
      console.log('Login Failed');
    },
  });

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Logo */}
      <div style={{ position: 'absolute', top: '20px', left: '20px' }}>
        <img src={logo} alt="logo" width="120" height="100" />
      </div>

      {/* Center content */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          textAlign: 'center',
        }}
      >
        <h2 style={{ fontSize: '80px', color: 'pink', fontWeight: 'bold' }}>
          Sign In
        </h2>

        {loading ? (
          <p style={{ fontSize: '20px', color: 'gray', marginTop: '30px' }}>
            Signing you in...
          </p>
        ) : (
          <button
            onClick={login}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              marginTop: '30px',
            }}
          >
            <img src={image} alt="Google Sign In" width="250" height="60" />
          </button>
        )}

        {message && (
          <p style={{ marginTop: '20px', color: 'red', fontSize: '18px' }}>
            {message}
          </p>
        )}
      </div>

      {/* Footer */}
      <footer
        style={{
          backgroundColor: 'black',
          color: 'white',
          textAlign: 'center',
          padding: '15px 0',
          position: 'absolute',
          bottom: '0',
          width: '100%',
        }}
      >
        � 2022 HYDAX Pvt. Ltd. All rights reserved.
      </footer>
    </div>
  );
};

export default SignIn;
